class RecommendedSwiper extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer) {
            const scrollbar = this.querySelector('.swiper-scrollbar');
            const prevButton = this.querySelector('.swiper-button-prev');
            const nextButton = this.querySelector('.swiper-button-next');
            const navigation = {};
            if (nextButton) {
                navigation.nextEl = nextButton;
            }
            if (prevButton) {
                navigation.prevEl = prevButton;
            }
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 2,
                spaceBetween: 30,
                // autoHeight:true,
                scrollbar: {
                    el: scrollbar,
                },
                navigation: navigation,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    750: {
                        slidesPerView: 1.7,
                        spaceBetween: 20
                    },
                    1000: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    }
                }
            });
        }
    }
}

customElements.define('recommended-swiper', RecommendedSwiper);
